import { Icons } from '../../icons/';
import { Typography } from '../primitives';
import { useTranslation, Trans } from '@rpi/i18n';

export const RequiredFieldIndicator = () => {
  const { t } = useTranslation(undefined, { keyPrefix: 'route.auth' });
  return (
    <Typography variant="footnote">
      <Trans
        i18nKey="route.auth.required_field"
        components={{
          'required-indicator': <Icons.Indicator />,
        }}
      />
    </Typography>
  );
};
